import {
    SET_MAP_CENTER,
    SET_MAP_LOADING,
    SET_MAP_MARKERS,
    CREATE_NEW_GOOGLE_MAP,
    CLEAR_GOOGLE_MAP,
    SET_MAP_ANCHOR_WINDOW,
    SET_MAP_STYLE_OPTIONS,
    SET_MAP_HEIGHT,
    SET_MAP_ZOOM,
    SET_PENDING_MAP_CENTER_EVENT,
    SET_MAP_IS_READY,
    CREATE_NEW_RETAIL_MATCH_OVERVIEW_MAP,
    CREATE_NEW_RETAIL_MATCH_MODAL_MAP,
    SET_RETAIL_MATCH_OVERVIEW_MAP_MARKERS,
    SET_MAP_STYLES,
} from "../Actions/Types";
import { IBuxtonDeck } from "../Models/IBuxtonDeck";
import { BuxtonDeck } from "../Util/BuxtonDeck";
import { MapStyleEnum } from "../Enums/Enums";
import { CSSObject } from "styled-components";

interface DefaultMapOptions {
  style: CSSObject;
  zoom: number;
  center: google.maps.LatLng;
}
export interface IReportMapState {
  googleMap: google.maps.Map;
  retailMatchOverviewMap: google.maps.Map;
  retailMatchModalMap: google.maps.Map;
  buxtonDeck: IBuxtonDeck;
  mapZoom: number;
  mapStyles: CSSObject;
  defaultMapOptions: DefaultMapOptions;
  mapStyleOptions: MapStyleEnum;
  mapCenter: google.maps.LatLng;
  pendingMapCenterEvent: boolean;
  showLoadingMarker: boolean;
  currentMarkers: google.maps.Marker[];
  currentAnchorWindow: google.maps.InfoWindow;
  isMapReady: boolean;
  retailMatchOverviewMapMarkers: google.maps.Marker[];
}

export const defaultState: IReportMapState = {
    googleMap: null,
    retailMatchOverviewMap: null,
    retailMatchModalMap: null,
    buxtonDeck: new BuxtonDeck(),
    mapZoom: 11,
    mapCenter: new google.maps.LatLng(36.7079, -96.9209),
    pendingMapCenterEvent: false,
    defaultMapOptions: {
        style: {
            width: "100%",
            height: "100%",
            borderRadius: "12px",
            marginTop: "20px",
        },
        zoom: 11,
        center: new google.maps.LatLng(36.7079, -96.9209),
    },
    mapStyles: {
        width: "100%",
        height: "100%",
        borderRadius: "12px",
        marginTop: "20px",
    },
    mapStyleOptions: MapStyleEnum.Light,
    currentMarkers: [],
    currentAnchorWindow: null,
    showLoadingMarker: false,
    isMapReady: false,
    retailMatchOverviewMapMarkers: [],
};

export const reportMap = (
    state: IReportMapState = { ...defaultState },
    action
): IReportMapState => {
    switch (action.type) {
        case CREATE_NEW_GOOGLE_MAP:
            return {
                ...state,
                googleMap: action.data,
            };

        case CREATE_NEW_RETAIL_MATCH_OVERVIEW_MAP:
            return {
                ...state,
                retailMatchOverviewMap: action.data,
            };

        case CREATE_NEW_RETAIL_MATCH_MODAL_MAP:
            return {
                ...state,
                retailMatchModalMap: action.data,
            };

        case SET_MAP_CENTER:
            return {
                ...state,
                mapCenter: action.data as google.maps.LatLng,
            };

        case SET_PENDING_MAP_CENTER_EVENT:
            return {
                ...state,
                pendingMapCenterEvent: action.data as boolean,
            };

        case SET_MAP_MARKERS:
            return {
                ...state,
                currentMarkers: action.data as google.maps.Marker[],
            };

        case SET_MAP_ANCHOR_WINDOW:
            return {
                ...state,
                currentAnchorWindow: action.data as google.maps.InfoWindow,
            };

        case SET_MAP_LOADING:
            return {
                ...state,
                showLoadingMarker: action.data as boolean,
            };

        case SET_MAP_STYLE_OPTIONS:
            return {
                ...state,
                mapStyleOptions: action.data as MapStyleEnum,
            };

        case SET_MAP_STYLES:
            return {
                ...state,
                mapStyles: {
                    ...state.mapStyles,
                    ...action.data,
                },
            };

        case SET_MAP_HEIGHT:
            return {
                ...state,
                mapStyles: {
                    ...state.mapStyles,
                    height: action.data as string,
                },
            };

        case SET_MAP_ZOOM:
            return {
                ...state,
                mapZoom: action.data as number,
            };

        case CLEAR_GOOGLE_MAP:
            state.currentMarkers.forEach((marker) => marker.setMap(null));
            state.buxtonDeck.clearProps();

            if (state.currentAnchorWindow) {
                state.currentAnchorWindow.close();
            }

            return {
                ...state,
                mapStyleOptions: MapStyleEnum.Light,
                mapStyles: state.defaultMapOptions.style,
                mapZoom: state.defaultMapOptions.zoom,
                mapCenter: state.defaultMapOptions.center,
                currentMarkers: [],
                currentAnchorWindow: null,
            };

        case SET_MAP_IS_READY:
            return {
                ...state,
                isMapReady: action.data as boolean,
            };

        case SET_RETAIL_MATCH_OVERVIEW_MAP_MARKERS:
            return {
                ...state,
                retailMatchOverviewMapMarkers: action.data as google.maps.Marker[],
            };

        default:
            return state;
    }
};
